import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';

export const pdfService = {
  authorizedCert: (
    certificateNr: string | undefined,
    sn: number | '' | undefined
  ) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/authorized`,
        { certificateNr, sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  originalCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/original`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  worksTestCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/works-test`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  typeApprovalCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/type-approval`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  dnvCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/dnv`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  docCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/doc`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
};
